'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$67(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_TwoFactorAuthView$$anon$67 as $c_Lpresto_TwoFactorAuthView$$anon$67 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$67.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$67;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$67() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$67 as $h_Lpresto_TwoFactorAuthView$$anon$67 };
$h_Lpresto_TwoFactorAuthView$$anon$67.prototype = $p;
$p.zo = (function(item) {
  return (!item.ov);
});
var $d_Lpresto_TwoFactorAuthView$$anon$67 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$67, "presto.TwoFactorAuthView$$anon$67", ({
  T6: 1,
  cv: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$67 as $d_Lpresto_TwoFactorAuthView$$anon$67 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$67.js.map
